export const GAME_RULES_VERSION = "2026-04-11-build-multiplier";
export const GAME_RULES_VERSION_MISMATCH_ERROR =
  "Refresh to load the latest Tavela rules, then start a new run.";

export type GameRulesVersionValidationResult =
  | {
      ok: true;
    }
  | {
      ok: false;
      error: string;
      status: 409;
    };

export function sanitizeGameRulesVersion(value: unknown): string {
  return typeof value === "string" ? value.trim().slice(0, 80) : "";
}

export function isGameRulesVersionMismatchError(value: unknown): boolean {
  return (
    typeof value === "string" &&
    value.trim().includes(GAME_RULES_VERSION_MISMATCH_ERROR)
  );
}

export function validateGameRulesVersionForSubmission(options: {
  clientRulesVersion: string;
  pendingRunRulesVersion: string;
  currentRulesVersion?: string;
}): GameRulesVersionValidationResult {
  const currentRulesVersion = options.currentRulesVersion ?? GAME_RULES_VERSION;
  const effectiveClientRulesVersion =
    options.clientRulesVersion.length > 0
      ? options.clientRulesVersion
      : options.pendingRunRulesVersion;

  if (
    effectiveClientRulesVersion === currentRulesVersion &&
    options.pendingRunRulesVersion === currentRulesVersion
  ) {
    return {
      ok: true
    };
  }

  return {
    ok: false,
    error: GAME_RULES_VERSION_MISMATCH_ERROR,
    status: 409
  };
}
